var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNearTheBeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.35474C3.0678 7.63029 5.20339 7.76807 6.62712 6.11475C8.32189 4.14669 12.9217 0.526945 16.738 5.54044C16.9178 5.77669 16.6601 6.1027 16.3756 6.0176C14.7255 5.52395 12.4371 5.41252 11.9661 7.6001C11.2542 10.9067 14.1017 10.4934 14.8136 9.66675C15.4433 8.93548 17.4656 7.68873 19.4023 8.55521C19.6634 8.67201 19.5588 8.99842 19.2781 9.05309C18.7201 9.16175 18.1583 9.4965 18.3729 10.4934C18.6576 11.8161 20.8644 11.5956 21.9322 11.3201M2 12.1467C2.71186 12.3147 3.99322 11.8987 4.84746 10.9067C5.80241 9.7978 7.61138 9.01944 9.51062 10.6412C9.73407 10.832 9.53428 11.1945 9.24065 11.1834C8.1883 11.1433 6.98305 11.4829 6.98305 12.9734C6.98305 15.4534 8.78199 16.1701 10.5424 15.8667C11.9661 15.6213 13.0339 14.3813 14.8136 14.7947C16.5932 15.208 17.661 16.616 19.7966 15.6213C21.6654 14.751 22.5254 15.7289 22.6441 15.8667M2 17.9334C4.49153 17.9334 4.13559 19.5867 6.62712 19.5867C9.11864 19.5867 8.76271 18.1013 11.2542 18.1013C13.7458 18.1013 14.4576 20 16.2373 20C18.0169 20 20.8644 16.448 23 20",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearTheBeach);
export default __webpack_public_path__ + "static/media/near_the_beach.67556c5aa3bcb16773dcd5c11692df94.svg";
export { ForwardRef as ReactComponent };